import { useMemo } from 'react';
import { useSafeUrlState } from '@mews/framework';
import { RoutingRuleTriggerType } from '@mews-commander/data-access';
import {
    RoutingRulesListFilterSchemaKeys,
    RoutingRulesListFilterValues,
    routingRulesListUrlFilterSchema,
} from '../schemas/routingRulesListFilterSchema';

export const useRoutingRuleListFilterDefaultValues = (): RoutingRulesListFilterValues => {
    const [search] = useSafeUrlState(routingRulesListUrlFilterSchema);

    return useMemo(
        () => ({
            [RoutingRulesListFilterSchemaKeys.Name]: undefined,
            [RoutingRulesListFilterSchemaKeys.Timing]: [
                RoutingRuleTriggerType.Continuous,
                RoutingRuleTriggerType.Legacy,
                RoutingRuleTriggerType.Recurring,
            ],
            [RoutingRulesListFilterSchemaKeys.Company]: undefined,
            [RoutingRulesListFilterSchemaKeys.TravelAgency]: undefined,
            ...search,
        }),
        [search]
    );
};
